import { useState } from 'react'
import { useSelector } from 'react-redux'
import { canViewFollowUpComparison } from 'services/results/follow-up-access'
import { StrokedButton } from 'views/components/UI/Buttons'
import SkillsComparisonDialog from 'views/components/FollowUp/SkillsComparisonDialog'

export default function BetesaComparisonAccess({
  processId,
  originalId,
  followUpId,
  userId,
  userName,
  completed,
}: {
  processId: number
  originalId: number
  followUpId: number
  userId: number
  userName: string
  completed: boolean
}) {
  const role = useSelector((state: any) => state.auth.role)
  const [open, setOpen] = useState(false)
  if (!canViewFollowUpComparison(role)) return null
  return (
    <>
      <StrokedButton disabled={!completed} onClick={() => setOpen(true)}>
        Comparar con original
      </StrokedButton>
      {open && (
        <SkillsComparisonDialog
          category="betesa"
          processId={processId}
          originalId={originalId}
          followUpId={followUpId}
          userId={userId}
          userName={userName}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
